import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, INLINES } from '@contentful/rich-text-types';
import { Col, Link, Text } from '@opendoor/bricks-next';

import { IBNComponentThemeConfig } from '../styles/ComponentTheme';

const FooterLegal = ({
  theme,
  extraLegalText,
  showCustomerTestimonialLegal,
  showEligibilityLegal,
  showPromotionLegal,
  showThePdpCopyrightLegal,
}: {
  theme: IBNComponentThemeConfig;
  extraLegalText?: Document | undefined;
  showCustomerTestimonialLegal?: boolean | undefined;
  showEligibilityLegal?: boolean | undefined;
  showPromotionLegal?: boolean | undefined;
  showThePdpCopyrightLegal?: boolean | undefined;
}) => {
  return (
    <Col
      backgroundColor={theme.bgPrimaryLight}
      borderRadius="$6x"
      padding="$8x"
      gap="$8x"
      // @ts-expect-error expect TODO
      color="$contentPrimary"
    >
      {extraLegalText && (
        <Col
          gap="$8x"
          // @ts-expect-error dynamic children inherit this color
          color={theme.contentPrimary}
        >
          {documentToReactComponents(extraLegalText, {
            renderNode: {
              [INLINES.HYPERLINK]: (node, children) => (
                <Link
                  href={node.data.uri}
                  analyticsName="cosmos-footer"
                  aria-label=""
                  variant="secondaryInverse"
                >
                  {children}
                </Link>
              ),
            },
          })}
        </Col>
      )}
      {showEligibilityLegal && (
        <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
          Offer eligibility and purchase price vary.
        </Text>
      )}
      {showCustomerTestimonialLegal && (
        <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
          Featured customers may have been compensated for their time. Their opinions and views are
          solely their own.
        </Text>
      )}
      {showThePdpCopyrightLegal && (
        <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
          Data is subject to copyright, and provided solely for personal, not commercial use. All
          property information should be verified by the recipient and none is guaranteed as
          accurate.
        </Text>
      )}
      {showPromotionLegal && (
        <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
          Eligibility may vary. Not all promotions may be combined.
        </Text>
      )}
      <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
        CA: Opendoor Brokerage Inc. DRE #02061130
      </Text>
      <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
        NY:{' '}
        <Link
          analyticsName="cosmos-landing-page-v2-footer-legal-link"
          aria-label="Licensed as Opendoor Brokerage LLC pdf link"
          href="https://odfil.es/static/documents/Dan+NY+Notarized+Doc.pdf"
          variant="secondaryInverse"
        >
          Licensed as Opendoor Brokerage LLC
        </Link>
        ,{' '}
        <Link
          analyticsName="cosmos-landing-page-v2-footer-legal-link"
          aria-label="Fair Housing Notice pdf link"
          href="https://odfil.es/static/documents/fair-housing-notice.pdf"
          variant="secondaryInverse"
        >
          Fair Housing Notice
        </Link>
      </Text>
      <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
        TX:{' '}
        <Link
          analyticsName="cosmos-landing-page-v2-footer-legal-link"
          aria-label="TREC Information About Brokerage Services pdf link"
          href="https://odfil.es/static/IABS_Jan_2026.pdf"
          variant="secondaryInverse"
        >
          TREC Information About Brokerage Services
        </Link>
        ,{' '}
        <Link
          analyticsName="cosmos-landing-page-v2-footer-legal-link"
          aria-label="TREC Consumer Protection Notice pdf link"
          href="https://www.trec.texas.gov/forms/consumer-protection-notice"
          variant="secondaryInverse"
        >
          TREC Consumer Protection Notice
        </Link>
      </Text>
      <Text tag="p" typography="$bodyMedium" color={theme.contentPrimary}>
        Opendoor Labs Inc. is dedicated to improving the accessibility of its Website and we view
        accessibility as a continually ongoing effort. Please contact us at{' '}
        <Link
          href="mailto:support@opendoor.com"
          aria-label="Contact support link"
          analyticsName="cosmos-contact-opendoor-email"
          variant="secondaryInverse"
        >
          support@opendoor.com
        </Link>{' '}
        with any support needs, feedback or suggestions.
      </Text>
    </Col>
  );
};

export default FooterLegal;
